import React, { useEffect, useState } from 'react';

import { TimezoneOffsets } from '../helpers/timezones';

import AutoComplete from './FormFields/Autocomplete';

const TimeZoneAutoSelect = ({
    error,
    helperText,
    id,
    label,
    name,
    onBlur,
    onChange,
    placeholder,
    value,
    ...props
}) => {

    const [convertedTimeZones, setConvertedTimeZones] = useState([]);

    useEffect(() => {
        convertTimeZone();
    }, []);

    const convertTimeZone = () => {
        const timeZones = [
            {
                items:     TimezoneOffsets,
                name:      'Time Zones',
                itemProps: { type: 'timeZones' }
            }
        ];

        setConvertedTimeZones(timeZones);
    };

    return (
        <AutoComplete
            grouped
            label={label || 'Time Zone'}
            placeholder={placeholder || 'Time Zone'}
            name="timeZone"
            id="timeZone"
            onBlur={onBlur}
            onChange={onChange}
            error={error}
            helperText={helperText}
            options={convertedTimeZones}
            value={value}
        />
    );
};

export default TimeZoneAutoSelect;
